import { TableRow, TableCell } from "@mui/material";
import { useState } from "react";
import {
  ExpirtReport,
  SaleableReport,
  formatDate,
} from "../../claim_button/DownloadReport";
import ScanButtton from "../../claim_button/ScanButton";
import CN from "../../claim_button/CN";
import ReconcilationHandler from "../../reconcilation/ReconcilationHandler";
import CNViewButton from "../../claim_button/CNViewButton";
import EditClaimButton from "./EditClaimButton";
import { TableEdit } from "./TableEdit";
import { getWarningToast } from "../../../toast";

export const TableViews = ({
  row,
  idx,
  setClaimRecord,
  editState,
  setEditState,
}) => {
  const style = {
    fontSize: "0.7em",
    textAlign: "center",
    padding: "0.5em",
  };

  const [open, setOpen] = useState(false);

  const editStateHandler = (record) => {
    if (record.stockists_master_id === editState.id) {
      setEditState({ id: null, status: false });
      return;
    }
    if (editState.status) {
      getWarningToast("Please save first.");
      return;
    }
    if (record.stockists_master_id === row.stockists_master_id) {
      setEditState({
        id: record.stockists_master_id,
        status: !editState.status,
      });
      return;
    }
    setEditState({ id: record.stockists_master_id, status: !editState.status });
  };

  return (
    <>
      <TableRow key={row.stockists_master_id}>
        <TableCell style={style}>{idx + 1}</TableCell>
        <TableCell style={style}>{row.stockists_master_id}</TableCell>
        <TableCell style={style}>{row.po_number}</TableCell>
        <TableCell style={style}>{row.party_master__name}</TableCell>
        <TableCell style={style}>{row.party_master__customer}</TableCell>
        <TableCell style={style}>
          {
            <input
              readOnly
              className="box_data_input"
              type="checkbox"
              checked={row.mark_box}
            />
          }
        </TableCell>
        <TableCell style={style}>{row?.order_types.join(" / ")}</TableCell>
        <TableCell style={style}>{row.lr_number}</TableCell>
        <TableCell style={style}>{row.lr_date}</TableCell>
        <TableCell style={style}>{row.ref_number}</TableCell>
        <TableCell style={style}>{row.ref_date}</TableCell>
        <TableCell style={style}>{row.received_date}</TableCell>
        <TableCell style={style}>{formatDate(row.created_on)}</TableCell>
        <TableCell style={style}>{row.created_by__username}</TableCell>
        <TableCell style={style}>
          <ExpirtReport row={row} setClaimRecord={setClaimRecord} />
          <SaleableReport row={row} setClaimRecord={setClaimRecord} />
          <ScanButtton row={row} />
          <ReconcilationHandler row={row} />
          <CN row={row} setClaimRecord={setClaimRecord} />
          <CNViewButton open={open} setOpen={setOpen} row={row} />
          <EditClaimButton row={row} editStateHandler={editStateHandler} />
        </TableCell>
      </TableRow>
      {editState.id === row.stockists_master_id && (
        <TableEdit
          row={row}
          setClaimRecord={setClaimRecord}
          setEditState={setEditState}
          editState={editState}
        />
      )}
    </>
  );
};
